module.exports = __webpack_public_path__ + "img/icon-all-plants.8e1b500b.svg";